<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <vx-card :title="$t('AddHoliday') | ToUppercase">
        <small>{{ $t("Name") | ToUppercase }}</small
        ><br />
        <vs-input class="w-full mb-6" type="text" name="name" v-model="holidayName"/>

        <small>{{$t('Date') |ToUppercase}}</small><br>
        <datepicker v-model="holidayDate"></datepicker>

        <div class="mt-5">
          <vs-button @click="addHoliday">{{ $t("Add") | ToUppercase }}</vs-button>
        </div>
        
      </vx-card>
    </div>
  </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    export default {
    components: {
        Datepicker
    },
    data: function () {
        return {
        holidayName: "",
        holidayDate: null
        };
    },
    created() {

    },
    methods: {
        addHoliday() {
        this.$vs.loading();

        const thisIns = this;
        this.$http
            .post("/holiday/add", {
            name: thisIns.holidayName,
            date: thisIns.holidayDate,
            })
            .then(function () {
                thisIns.$vs.notify({
                    text: "Praznik shranjen",
                    color: "success",
                });
                thisIns.$router.push('/holiday/all');
            })
            .catch(function () {
            thisIns.$vs.notify({
                text: "Napaka pri shranjevanju",
                color: "danger",
                iconPack: "feather",
                icon: "icon-alert-circle",
            });
            })
            .finally(function () {
            thisIns.$vs.loading.close();
            });
        },
    },
    filters: {
        ToUppercase: function (value) {
        if (!value) return "";
        value = value.toString();
        return value.toUpperCase();
        },
    },
    };
</script>